<template>
  <div class="app-container">
    <div class="anjian-wrap">
      <div class="common-section-bg anjian-shaixuan">
        <div class="shaixuan-item">
          <el-input v-model="listQuery.key"
                    clearable
                    placeholder="请输入名称" />
        </div>
        <div class="shaixuan-item">
          <!-- @keyup.enter.native="handleFilter" -->
          <el-button type="primary"
                     style="background: #1067e0; border-color: #1067e0"
                     @click="handleFilter()"
                     icon="el-icon-search">
            {{ $t("table.search") }}
          </el-button>
        </div>
        <div class="shaixuan-item">
          <el-button @click="handleCreate"
                     type="primary"
                     style="background: #1067e0; border-color: #1067e0"
                     icon="el-icon-plus">
            {{ $t("table.add") }}
          </el-button>
        </div>
      </div>
      <div class="common-section-bg common-section-top biaoge-data">
        <el-table v-loading="listLoading"
                  :data="tableData"
                  style="width: 100%">
          <el-table-column prop="id"
                           label="id" />
          <el-table-column prop="areaname"
                           label="名称" />
          <el-table-column prop="is_show"
                           label="显示">
            <template slot-scope="scope">
              <el-switch :value="scope.row.is_show==1 ? true : false"
                         active-color="#13ce66"
                         inactive-color="#cccccc"
                         @change="changeStatus(scope.$index,scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="admin"
                           label="排序"
                           width="120">
            <template slot-scope="scope">
              <el-input-number size="mini"
                               style="width: 100px"
                               v-model="scope.row.sort"
                               controls-position="right"
                               @change="handleChange(scope.row)"
                               :min="0"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           width="300">
            <template slot-scope="scope">
              <el-button type="primary"
                         @click="append(scope.row.id)">
                市管理
              </el-button>
              <el-button @click="showEdit(scope.row.id)"
                         type="primary"
                         style="
                                      background: #1067e0;
                                      border-color: #1067e0;
                                  ">
                编辑
              </el-button>
              <el-button @click="delFun(scope.row.id)"
                         type="primary"
                         style="
                                      background: #ff4040;
                                      border-color: #ff4040;
                                  ">
                删除
              </el-button>

            </template>
          </el-table-column>

        </el-table>
        <!-- 分页 -->
        <pagination v-show="total"
                    :total="total"
                    :page.sync="listQuery.page"
                    :limit.sync="listQuery.size"
                    @pagination="getList" />
      </div>
    </div>
    <el-dialog title="区域"
               :visible.sync="showDrawer">
      <el-form ref="ruleForm"
               :model="danwei"
               :rules="rules">
        <el-form-item label="名称"
                      prop="areaname"
                      label-width="120px">
          <el-input v-model="danwei.areaname"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="城市代码"
                      prop="provinceid"
                      label-width="120px">
          <el-input v-model="danwei.provinceid"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="经度"
                      prop="lng"
                      label-width="120px">
          <el-input v-model="danwei.lng"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="纬度"
                      prop="lat"
                      label-width="120px">
          <el-input v-model="danwei.lat"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序"
                      prop="sort"
                      label-width="120px">
          <el-input v-model="danwei.sort"
                    autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="showDrawer = false">取 消</el-button>
        <el-button type="primary"
                   v-loading="tijiaoLoading"
                   @click="tijiao('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import area from '@/api/console/area'
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
export default {
  components: {
    Pagination,
  },
  data () {
    return {
      tijiaoLoading: false,
      isEdit: 0, // 0新增 1编辑
      showDrawer: false,
      listLoading: false,
      total: 0,
      danwei: {
        areaname: "",
        provinceid: "",
        lng: "",
        lat: "",
        sort: 0
      },
      rules: {
        areaname: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        provinceid: [{
          required: true,
          message: '请输入行政区划代码',
          trigger: 'blur'
        }],
        lat: [{
          required: true,
          message: '请输入纬度',
          trigger: 'blur'
        }],
        lng: [{
          required: true,
          message: '请输入经度',
          trigger: 'blur'
        }],
      },

      listQuery: {
        key: "",
        page: 1,
        size: 10
      },
      tableData: []
    }
  },
  created () {
    this.getList();
  },
  methods: {
    /**
     * @name: 子地区
     * @param {*} id
     * @return {*}
     * @desc: 
     */
    append (id) {
      this.$router.push({
        path: '/base/sarea',
        query: {
          id: id
        }
      })
    },
    /**
     * @name: 搜索
     * @return {*}
     * @desc: 
     */
    handleFilter () {
      this.listQuery.page = 1;
      this.getList();
    },
    /**
     * @name: 获取列表
     * @return {*}
     * @desc: 
     */
    getList (val) {
      if (val && val.page) {
        this.listQuery.page = val.page;
      }
      this.listLoading = true;
      area.list(this.listQuery).then(res => {
        this.listLoading = false;
        if (res.code == 200) {
          this.tableData = res.result.list;
          this.total = res.result.total;
        }
      })
    },
    /**
     * @name: 点击子项 0新增 1编辑
     * @param {*} type
     * @param {*} id
     * @return {*}
     * @desc: 
     */
    handleCreate () {
      let that = this;
      this.isEdit = 0;
      this.showDrawer = true;
    },
    showEdit (index) {
      let that = this;
      this.isEdit = 1;
      this.showDrawer = true;
      that.id = index;
      area.detail({
        id: that.id
      }).then(res => {
        if (res.code == 200) {
          this.danwei.areaname = res.result.areaname;
          this.danwei.provinceid = res.result.provinceid;
          this.danwei.lng = res.result.lng;
          this.danwei.lat = res.result.lat;
          this.danwei.sort = res.result.sort;
        }
      })
    },
    /**
     * @name: 提交
     * @param {*} formName
     * @return {*}
     * @desc: 
     */
    tijiao (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.id) {
            // 编辑
            let params = this.danwei;
            params.id = this.id;
            this.tijiaoLoading = true;
            area.edit(params).then(res => {
              this.tijiaoLoading = false;
              if (res.code == 200) {
                this.$message.success(res.message);
                this.closeDrawerFun();
                this.getList(this.listQuery.page)
              } else {
                this.$message.error(res.message);
              }

            })
          } else {
            // 新增
            this.tijiaoLoading = true;
            area.create(this.danwei).then(res => {
              this.tijiaoLoading = false;
              if (res.code == 200) {
                this.$message.success(res.message);
                this.closeDrawerFun();
                this.getList();
              } else {
                this.$message.error(res.message);
              }
            })
          }

        } else {
          this.$message.warning(this.$t('form.verifyMsg'))
        }
      })
    },
    /**
     * @name: 关闭弹层
     * @return {*}
     * @desc: 
     */
    closeDrawerFun () {
      this.showDrawer = false;
      this.resetForm();
    },
    /**
     * @name: 删除
     * @param {*} row
     * @return {*}
     * @desc: 
     */
    delFun (row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        area.remove({
          id: row
        }).then(res => {
          if (res.code == 200) {
            this.$message.success(res.message);
            this.getList(this.listQuery.page)
          } else {
            this.$message.error(res.message);
          }
        })
      }).catch(() => { })

    },
    /**
     * @name: 清空
     * @return {*}
     * @desc: 
     */
    resetForm () {
      this.id = null;
      this.danwei.areaname = '';
      this.danwei.provinceid = '';
      this.danwei.lng = '';
      this.danwei.lat = '';
      this.danwei.sort = 0;
      this.danwei.id = 0;
      this.$refs["ruleForm"].resetFields();
    },
    changeStatus (index, row) {
      let status = row.is_show == 1 ? 0 : 1;
      let params = {
        id: row.id,
        status: status
      };
      this.listLoading = true;
      area.status(params).then(res => {
        this.listLoading = false;
        if (res.code == 200) {
          let item = row;
          item.status = status;
          this.getList(this.listQuery.page);
        }
      })
    },
    // 排序变更
    handleChange (row) {
      let params = {
        id: row.id,
        sort: row.sort
      };
      area.sort(params).then(res => {
        if (res.code == 200) {
          this.getList(this.listQuery.page);
        } else {
          this.$message.error(res.message);
        }
      })
    },

  }
}
</script>
